/**
 * THIS IS A TEMPORARY FILE WHILE WE UPGRADE TO GT AMERICA GRADUALLY.
 * THE FONT FAMILY MUST BE HANDLED IN OUR BIT COMPONENT
 */

import { deepmerge } from "@mui/utils";

import { MoodysThemeOptions } from "@moodys/federated/types/theme/muiThemes/moodysTheme.types";

import rebrandFonts from "./fonts.module.scss";
import { ThemeMode, generateThemeOverrides } from "./theme";

export const generateSiteRebrandThemeOverrides = ({
  themeMode,
}: {
  themeMode: ThemeMode;
}): MoodysThemeOptions => {
  const baseThemeOverrides = generateThemeOverrides({
    themeMode,
  });

  const siteRebrandThemes = {
    typography: {
      fontFamily: rebrandFonts.fontFamily,
      h1: {
        fontFamily: rebrandFonts.fontFamily,
      },
      h2: {
        fontFamily: rebrandFonts.fontFamily,
      },
      h3: {
        fontFamily: rebrandFonts.fontFamily,
      },
      h4: {
        fontFamily: rebrandFonts.fontFamily,
      },
      h5: {
        fontFamily: rebrandFonts.fontFamily,
      },
      h6: {
        fontFamily: rebrandFonts.fontFamily,
      },
      subtitle1: {
        fontFamily: rebrandFonts.fontFamily,
      },
      subtitle2: {
        fontFamily: rebrandFonts.fontFamily,
      },
      body1: {
        fontFamily: rebrandFonts.fontFamily,
      },
      body2: {
        fontFamily: rebrandFonts.fontFamily,
      },
      button: {
        fontFamily: rebrandFonts.fontFamily,
      },
      caption: {
        fontFamily: rebrandFonts.fontFamily,
      },
      overline: {
        fontFamily: rebrandFonts.fontFamily,
      },
    },
  };

  return deepmerge(baseThemeOverrides, siteRebrandThemes);
};
